import { parse } from '../pegjs/mysql.pegjs'

export default {
  [PARSER_NAME] : parse,
}
